import React from 'react';
import { Star, BadgeMinus, Building2 } from 'lucide-react';

export default function LicenseTypeIcon({ type }) {
  if (type === 'PRO') {
    return <Star color="#ffa600" title="Pro" style={{ verticalAlign: 'middle' }} />;
  }
  if (type === 'GROUP') {
    return <Building2 color="#2563eb" title="Group" style={{ verticalAlign: 'middle' }} />;
  }
  return <BadgeMinus color="#64748b" title="Básica" style={{ verticalAlign: 'middle' }} />;
}
